/**
 * TutorHomeScreen — l'accueil du masteur, « Ma journée » (l'onglet `dashboard` de la coquille).
 *
 * Un fil : les droits lus dans leur contexte, les lectures (`useTutorHomeData`), le view-model
 * (`tutorHomeViewModel`), les gestes (`useTutorHomeState`), la page du DS.
 */
import React, { useContext } from "react"
import { useSelector } from "react-redux"

import { TutorHomePage } from "../../../../../../design-system/tutor"
import { AbilityContext } from "../../../../../../data/utility/Can"
import { tutorHomeViewModel } from "../../../../view-models/tutor/Home/tutorHomeViewModel"
import { useTutorHomeData } from "./useTutorHomeData"
import { useTutorHomeState } from "./useTutorHomeState"

type Ability = { can?: (action: string, subject: string) => boolean } | undefined

export function TutorHomeScreen() {
    const ability = useContext(AbilityContext) as Ability
    const canSeeStudents = !!ability?.can?.("read", "my_students")
    const canSeeTasks = !!ability?.can?.("read", "my_tutor_profile_completion")
    const vm = useSelector((state: unknown) => tutorHomeViewModel(state, { canSeeStudents, canSeeTasks }))
    const { refresh, refreshing, notice, dismissNotice, tellFailure } = useTutorHomeData()
    const gestures = useTutorHomeState(vm, tellFailure)

    return (
        <TutorHomePage
            firstname={vm.firstname}
            loading={vm.loading}
            refreshing={refreshing}
            onRefresh={refresh}
            notice={notice}
            onDismissNotice={dismissNotice}
            canSeeStudents={vm.canSeeStudents}
            todaySessions={vm.todaySessions}
            upcomingSessions={vm.upcomingSessions}
            offer={vm.offer}
            pendingOffersCount={vm.pendingOffersCount}
            todos={vm.todos}
            score={vm.score}
            earnings={vm.earnings}
            monthReset={vm.monthReset}
            {...gestures}
            testID="tutor-home"
        />
    )
}
